import { render } from "./EventCalendarCard.vue?vue&type=template&id=d9dffc3e&scoped=true"
import script from "./EventCalendarCard.vue?vue&type=script&lang=js"
export * from "./EventCalendarCard.vue?vue&type=script&lang=js"

import "./EventCalendarCard.vue?vue&type=style&index=0&id=d9dffc3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9dffc3e"

export default script